var map = {
	"./ic-close-small-light.svg": "49ef",
	"./ic-complete.svg": "e2d7",
	"./ic-facebook.svg": "15b8",
	"./ic-line.svg": "e5f1",
	"./ic-mail.svg": "e366",
	"./ic-system-viabus.svg": "e104",
	"./ic-twitter.svg": "ac55",
	"./icon-32-ic-done-oval.svg": "f6bb",
	"./icon-32-ic-hourglass.svg": "f9a9",
	"./icon-32-ic-warning-oval.svg": "cff7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";